import RefData from 'ref-data';

//A simple getter used to get if an experience is score based. This only applies to quiz type experiences, based on their subtypeRef, hence why we drill to the subtypeRef.
const isScoreSubtype = (model) =>
  model.subtypeRef && model.subtypeRef.id === RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZSCORE;
//A simple getter used to get if an experience is a Chatbot. This only applies to quiz type experiences, based on their subtypeRef, hence why we drill to the subtypeRef.
const isChatbotSubtype = (model) =>
  model.subtypeRef && model.subtypeRef.id === RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZCATEGORYCHATBOT;
//function for parsing values of presentationConfig properties
const deserializePresentationConfig = (value) => {
  if (typeof value === 'string') {
    if (value.toLowerCase() === 'false') {
      return false;
    }
    if (value.toLowerCase() === 'true') {
      return true;
    }
    // Check if the string is a numeric value
    if (!isNaN(value) && !isNaN(parseFloat(value))) {
      return parseFloat(value);
    }
  }
  return value; // Return the original value if it's not 'true' or 'false' string or a number
};
// this is needed to turn presentationConfig object to query string
const serializePresentationConfig = (obj) => {
  return Object.keys(obj)
    .map((key) => `${key}=${obj[key] !== null ? encodeURIComponent(obj[key]) : ''}`)
    .join('&');
};

export { isScoreSubtype, isChatbotSubtype, deserializePresentationConfig, serializePresentationConfig };
